import { Form } from 'factorial-form'

class CompanyBankAccount extends Form {
  constructor(values: object) {
    super(values, {
      bank_name: 'string',
      account: 'string',
      code: 'string',
    })
  }
}

export default CompanyBankAccount
